import { styled, typography } from '@pulse-web-ui/theme';

export const SectionHeader = styled.h4<{
  $fontSize?: string;
  $marginBottom?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 28}px;
  ${({ $fontSize }) => $fontSize ?? typography.medium20};

  @media (min-width: 768px) {
    margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 24}px;
    ${({ $fontSize }) => $fontSize ?? typography.medium24};
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
